"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.asinDocs = void 0;
var asinDocs = exports.asinDocs = {
  name: 'asin',
  category: 'Trigonometry',
  syntax: ['asin(x)'],
  description: 'Compute the inverse sine of a value in radians.',
  examples: ['asin(0.5)', 'asin(sin(0.5))'],
  seealso: ['sin', 'acos', 'atan']
};